__turbopack_context__.v({
  "activeDelegationIcon": "WalletChecker-module-scss-module__ElycZW__activeDelegationIcon",
  "arrowBody": "WalletChecker-module-scss-module__ElycZW__arrowBody",
  "arrowHead": "WalletChecker-module-scss-module__ElycZW__arrowHead",
  "checkBtn": "WalletChecker-module-scss-module__ElycZW__checkBtn",
  "clearBtn": "WalletChecker-module-scss-module__ElycZW__clearBtn",
  "consolidationActiveIcon": "WalletChecker-module-scss-module__ElycZW__consolidationActiveIcon",
  "consolidationPlusIcon": "WalletChecker-module-scss-module__ElycZW__consolidationPlusIcon",
  "consolidationRecommendationIcon": "WalletChecker-module-scss-module__ElycZW__consolidationRecommendationIcon",
  "error": "WalletChecker-module-scss-module__ElycZW__error",
  "formInput": "WalletChecker-module-scss-module__ElycZW__formInput",
  "infoOk": "WalletChecker-module-scss-module__ElycZW__infoOk",
  "recommendationsList": "WalletChecker-module-scss-module__ElycZW__recommendationsList",
  "supportingAddress": "WalletChecker-module-scss-module__ElycZW__supportingAddress",
  "walletCheckerContainer": "WalletChecker-module-scss-module__ElycZW__walletCheckerContainer",
  "walletInput": "WalletChecker-module-scss-module__ElycZW__walletInput",
  "walletOk": "WalletChecker-module-scss-module__ElycZW__walletOk",
});
